import React, { useState } from "react";
import { T } from "../../app/tokens.js";
import { ChevronRight, Edit2, Plus } from "lucide-react";
import { OkrProgressBar } from "./OkrProgressBar.jsx";
import { OkrStatusBadge } from "./OkrStatusBadge.jsx";
import { OkrKeyResult } from "./OkrKeyResult.jsx";

export function OkrObjective({
  objective,
  keyResults = [],
  canEdit = false,
  onEditObj,
  onAddKR,
  onEditKR,
  onAddInitiative,
  onEditInitiative,
  onViewUpdates
}) {
  const [expanded, setExpanded] = useState(true);
  const [hover, setHover] = useState(false);

  const {
    id,
    name,
    fiscalYear,
    status,
    rollupPercent
  } = objective;

  const hasKRs = keyResults.length > 0;

  return (
    <div style={{ marginBottom: 16, background: T.card, borderRadius: 8, border: `1px solid ${T.border}`, overflow: "hidden", boxShadow: T.shadowTileXs }}>
      <div
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={{
          display: "flex", alignItems: "center", gap: 16,
          padding: "16px",
          background: hover ? T.hoverBg : T.white,
          borderBottom: expanded && hasKRs ? `1px solid ${T.border}` : "none",
          transition: "background 0.2s ease"
        }}
      >
        <button
          type="button"
          onClick={() => setExpanded(!expanded)}
          style={{
            background: "transparent", border: "none", cursor: "pointer",
            padding: 4, display: "grid", placeItems: "center",
            color: hasKRs ? T.dark : T.line,
            opacity: hasKRs ? 1 : 0,
            pointerEvents: hasKRs ? "auto" : "none",
            transform: expanded ? "rotate(90deg)" : "none",
            transition: "transform 0.2s ease"
          }}
        >
          <ChevronRight size={18} />
        </button>

        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: T.fsXs, fontWeight: T.fwBold, color: T.mid, background: T.tile, padding: "2px 6px", borderRadius: 4 }}>FY{fiscalYear}</span>
            <span style={{ fontSize: T.fsLg, fontWeight: T.fwBold, color: T.dark, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {name}
            </span>
          </div>
        </div>

        <div style={{ width: 100, flexShrink: 0 }}>
          <OkrStatusBadge status={status} />
        </div>

        <div style={{ width: 160, flexShrink: 0 }}>
          <OkrProgressBar percent={rollupPercent} size="md" color={T.greenDeep} />
        </div>

        {canEdit && (
          <div style={{ width: 72, flexShrink: 0, display: "flex", justifyContent: "flex-end", gap: 4 }}>
            <button
              type="button"
              onClick={() => onAddKR(objective)}
              style={{
                background: "transparent", border: "none", cursor: "pointer",
                color: T.mid, padding: 6, borderRadius: 4,
                opacity: hover ? 1 : 0, transition: "opacity 0.2s ease"
              }}
              title="Add Key Result"
            >
              <Plus size={16} />
            </button>
            <button
              type="button"
              onClick={() => onEditObj(objective)}
              style={{
                background: "transparent", border: "none", cursor: "pointer",
                color: T.blue, padding: 6, borderRadius: 4,
                opacity: hover ? 1 : 0, transition: "opacity 0.2s ease"
              }}
              title="Edit Objective"
            >
              <Edit2 size={16} />
            </button>
          </div>
        )}
      </div>

      {expanded && hasKRs && (
        <div>
          {keyResults.map(kr => (
            <OkrKeyResult
              key={kr.id}
              keyResult={kr}
              initiatives={kr.initiatives || []}
              canEdit={canEdit}
              onEditKR={onEditKR}
              onAddInitiative={onAddInitiative}
              onEditInitiative={onEditInitiative}
              onViewUpdates={onViewUpdates}
            />
          ))}
        </div>
      )}
    </div>
  );
}
